import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Drawer, Button, Input, Space, Row, Col, DatePicker, Card, Tag, message, Select } from 'antd';
import { } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import BaseSelect from '../../components/Elements/BaseSelect';
import moment from 'moment';
import BaseRadioList from '../../components/Elements/BaseRadios';
import InputMask from "react-input-mask";
import { createCustomerNew } from '../../redux/actions/customerActions';
import { _newLine, CustomerCardStatus, customerGender, CustomerScheduleType } from '../../utils/helpers';
import { getListProvinces, getListDistricts, getListWards } from '../../redux/actions/RegionsActions';
import { getCustomerSourceActive } from '../../redux/actions/CustomerSourceActions';
import { getBranchActive } from '../../redux/actions/BranchActions';
import FamilyRelationships from '../customers/items/FamilyRelationships';
import { getCustomerGroupActive } from '@/redux/actions/CustomerGroup';
import { getCustomerStatusActive } from '@/redux/actions/CustomerStatusActions';

const CreateProfileForm = (props) => {

    const [form] = Form.useForm();
    const { visible, currentItem, onCancel, reloadData } = props;
    const formRef = React.createRef();

    const [isLoading, setIsLoading] = useState(false);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [showScheduleField, setShowScheduleField] = useState(false);

    const provinces = useSelector(state => state.RegionsReducer.list_provinces);
    const customerSources = useSelector(state => state.CustomerSourceReducer.customer_source_active_list);
    const branchList = useSelector(state => state.BranchReducer.branchActiveList);
    const customerStatus = useSelector(state => state.CustomerStatusReducer.customerStatusActiveList);
    const customerGroups = useSelector(state => state.CustomerGroup.active_list);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListProvinces());
        dispatch(getCustomerSourceActive());
        dispatch(getBranchActive());
        dispatch(getCustomerGroupActive());
        dispatch(getCustomerStatusActive());
    }, []);

    useEffect(() => {
        if (currentItem) {
            form.setFieldsValue(currentItem);

            // dispatch(getListDistricts({ province_code: currentItem.province_code })).then((res) => {
            //     setDistricts(res.data);
            // });

            dispatch(getListWards({ province_code: currentItem.province_code })).then((res2) => {
                setWards(res2.data);
            });
        }
    }, [currentItem]);


    const handleSubmit = (values) => {
        if (currentItem) {
            setIsLoading(true);
            values.source_type = 'from_potential';
            values.customer_potential_id = currentItem?.id;
            dispatch(createCustomerNew(values)).then(res => {
                onClose();
            }).catch(err => {
                setIsLoading(false);
            })
        }
        console.log("Dữ liệu submit:", values);
    };

    const onClose = () => {
        reloadData();
        onCancel();
        form.resetFields();
        setIsLoading(false);
    }

    const loadDistricts = async (province_code) => {
        if (province_code) {
            try {
                const res = await dispatch(getListDistricts({ province_code }));
                form.setFieldsValue({ district_code: undefined, wards_code: undefined });
                setDistricts(res.data);
                setWards([]);
            } catch (error) {
                console.error("Lỗi khi tải danh sách quận/huyện:", error);
            }
        }
    };

    const loadWards = async (province_code) => {
        if (province_code) {
            try {
                const res = await dispatch(getListWards({ province_code })); // Gọi action
                form.setFieldsValue({ wards_code: undefined });
                setWards(res.data);
            } catch (error) {
                console.error("Lỗi khi tải danh sách phường/xã:", error);
            }
        }
    };

    const handleChangeCustomerStatus = (value) => {
        if (value == 3) { // 3: Đã đặt được lịch hẹn
            setShowScheduleField(true)
        } else {
            setShowScheduleField(false)
        }
    }

    const handleError = (error) => {
        console.log(error);
        message.error('Vui lòng điền đầy đủ các trường bắt buộc');
    }

    const handleBirthdayChange = (e) => {
        const value = e.target.value;
        const date = moment(value, "DD/MM/YYYY", true);

        if (date.isValid()) {
            const age = moment().diff(date, "years");
            form.setFieldsValue({ age });
        } else {
            form.setFieldsValue({ age: "" });
        }
    };


    var branch_id = null;
    var gender = 'khac';

    var genderMale = ['nam', 'Nam'];
    var genderFemale = ['nữ', 'nu', 'Nữ', 'Nu'];

    if (currentItem) {
        if (currentItem.province_code !== null && currentItem.province_code !== "") {
            // eslint-disable-next-line default-case
            switch (currentItem.province_code.trim()) {
                case '01':
                    branch_id = 2; // Hà Nội
                    break;
                case '48':
                    branch_id = 1; // Đà Nẵng
                    break;
            }
        }
        if (currentItem.gender !== null && currentItem.gender !== "") {
            if (genderMale.includes(currentItem.gender.trim())) {
                gender = "nam";
            } else if (genderFemale.includes(currentItem.gender.trim())) {
                gender = "nu";
            }
        }
    }

    useEffect(() => {
        if (currentItem) {
            const birthday = currentItem.birthday;

            // Nếu chỉ có 4 số (tức là năm), thì thêm 01/01 vào trước
            const formattedBirthday =
                birthday && /^\d{4}$/.test(birthday)
                    ? `01/01/${birthday}`
                    : birthday;

            const date = moment(formattedBirthday, "DD/MM/YYYY", true);
            const age = date.isValid() ? moment().diff(date, "years") : "";

            form.setFieldsValue({
                ...currentItem,
                birthday: formattedBirthday,
                age,
            });
        } else {
            form.resetFields();
        }
    }, [currentItem]);

    const initialValues = {
        full_name: currentItem?.full_name,
        branch_id: branch_id,
        gender: gender,
        phones: currentItem?.phone ? [currentItem?.phone] : [],
        customer_source_id: 48, // Khách thẻ
        card_number: currentItem?.card_number || null,
        customer_status_id: null,
        schedule_name: 'TUVAN',
        schedule_time: null,
        card_status: 'none',
        group_ids: [],
        result_content: _newLine(currentItem?.result_content),
        note: _newLine(currentItem?.note),
        province_code: currentItem?.province_code || null,
        district_code: currentItem?.district_code || null,
        wards_code: currentItem?.wards_code || null,
        address: currentItem?.address || null
    }


    return (
        <Drawer
            visible={visible}
            title={`${currentItem ? currentItem?.full_name : ""} - ${currentItem?.code}`}
            onClose={() => onClose()}
            maskClosable={false}
            width={isMobile ? '100%' : '70%'}
            forceRender={true}
            footer={
                <div style={{ textAlign: 'right', }}>
                    <Space>
                        <Button key="back" onClick={() => onClose()}>
                            Huỷ
                        </Button>
                        <Button
                            loading={isLoading}
                            key="submit"
                            type="primary"
                            onClick={(e) => form.submit(e)}
                        >
                            Tạo hồ sơ
                        </Button>
                    </Space>
                </div>
            }
        >
            {visible && (
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={initialValues}
                    ref={formRef}
                    className='form-customer'
                    onFinish={(values) => handleSubmit(values)}
                    onFinishFailed={(values) => handleError(values)}
                >
                    <Card title={<><Tag color='#0b2b33'>1</Tag> Thông tin khách hàng</>} size='small'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Row gutter={16}>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Tên khách hàng"
                                            name="full_name"
                                            rules={[{ required: true, message: 'Bắt buộc nhập' }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Cơ sở"
                                            name="branch_id"
                                            rules={[{ required: true, message: 'Bắt buộc chọn' }]}
                                        >
                                            <BaseSelect
                                                options={branchList || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Giới tính"
                                            name="gender"
                                            rules={[{ required: true, message: "Bắt buộc chọn" }]}
                                        >
                                            <BaseRadioList
                                                options={customerGender || []}
                                                name="gender"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={16}>
                                        <Form.Item
                                            label={<>Số điện thoại <span className='ant-form-item-extra-custom'>(Nhập SĐT, cách nhau bằng dấu phẩy, bắt đầu bằng 0 (vd: 0978015988).)</span></>}
                                            name="phones"
                                            rules={[{ required: false, message: 'Nhập ít nhất một số điện thoại!' }]}
                                        >
                                            <Select
                                                mode="tags"
                                                style={{ width: '100%' }}
                                                placeholder="Nhập SĐT, cách nhau bằng dấu phẩy, bắt đầu bằng 0 (vd: 0978015988)."
                                                tokenSeparators={[',']}
                                                open={false} // Ẩn dropdown
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Nguồn"
                                            name="customer_source_id"
                                            rules={[{ required: true, message: 'Bắt buộc chọn' }]}
                                        >
                                            <BaseSelect
                                                options={customerSources || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Ngày sinh"
                                            name="birthday"
                                            rules={[{ required: false, message: "Bắt buộc nhập" }]}
                                        >
                                            <InputMask
                                                mask="99/99/9999"
                                                placeholder="dd/mm/yyyy"
                                                onChange={handleBirthdayChange}
                                            >
                                                {(inputProps) => <Input {...inputProps} />}
                                            </InputMask>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Tuổi"
                                            name="age"
                                            rules={[{ required: false, message: "Bắt buộc nhập" }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label="Mã số thẻ cũ"
                                            name="card_number"
                                            rules={[{ required: false, message: 'Bắt buộc nhập' }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={8}>
                                        <Form.Item
                                            label='Trạng thái khách hàng'
                                            name="customer_status_id"
                                            rules={[{ required: true, message: 'Bắt buộc chọn' }]}
                                        >
                                            <BaseSelect
                                                options={customerStatus || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                                onChange={handleChangeCustomerStatus}
                                            />
                                        </Form.Item>
                                    </Col>
                                    {showScheduleField && <>
                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                label='Kiểu lịch hẹn'
                                                name="schedule_name"
                                                rules={[{ required: true, message: 'Bắt buộc chọn' }]}
                                            >
                                                <BaseSelect
                                                    options={CustomerScheduleType || []}
                                                    showSearch
                                                    placeholder="Chọn một bản ghi"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                label="Thời gian"
                                                name="schedule_time"
                                                rules={[{ required: true, message: 'Bắt buộc chọn' }]}
                                            >
                                                <DatePicker
                                                    style={{ width: '100%' }}
                                                    showTime={{ format: 'HH:mm', defaultValue: moment('00:00', 'HH:mm') }} // Giới hạn giờ và phút là 00:00
                                                    format="DD/MM/YYYY HH:mm"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </>}
                                    <Col xs={24} md={24}>
                                        <Form.Item
                                            label="Trạng thái thẻ"
                                            name="card_status"
                                            rules={[{ required: false, message: 'Bắt buộc nhập' }]}
                                        >
                                            <BaseRadioList
                                                options={CustomerCardStatus ?? []}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Form.Item
                                            label="Nhóm"
                                            name="group_ids"
                                            rules={[{ required: false, message: 'Bắt buộc chọn' }]}
                                        >
                                            <BaseSelect
                                                options={customerGroups ?? []}
                                                optionValue="id"
                                                optionLabel="name"
                                                placeholder="Chọn 1 hoặc nhiều nhóm"
                                                showSearch={true}
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={16}>
                        <Col xs={24} md={24}>
                            <Form.Item
                                label="Kết quả tele"
                                name="result_content"
                                rules={[{ required: false, message: 'Bắt buộc nhập' }]}
                            >
                                <Input.TextArea rows={8} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                label="Ghi chú"
                                name="note"
                                rules={[{ required: false, message: 'Bắt buộc nhập' }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Card title={<><Tag color='#0b2b33'>2</Tag> Thông tin nhân khẩu</>} size='small' className='mt-4'>
                        <Row gutter={16}>
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Tỉnh, thành phố"
                                    name="province_code"
                                    rules={[{ required: true, message: "Bắt buộc chọn" }]}
                                >
                                    <BaseSelect
                                        options={provinces || []}
                                        optionValue="code"
                                        optionLabel="name"
                                        showSearch
                                        placeholder="Chọn một bản ghi"
                                        style={{ width: '100%' }}
                                        onChange={(code) => loadWards(code)}
                                    />
                                </Form.Item>
                            </Col>
                            {/* <Col xs={24} md={8}>
                                <Form.Item
                                    label="Huyện (Q. Tx)"
                                    name="district_code"
                                    rules={[{ required: false, message: "Bắt buộc chọn" }]}
                                >
                                    <BaseSelect
                                        options={districts || []}
                                        optionValue="code"
                                        optionLabel="name"
                                        showSearch
                                        placeholder="Chọn một bản ghi"
                                        style={{ width: '100%' }}
                                        onChange={(code) => loadWards(code)}
                                    />
                                </Form.Item>
                            </Col> */}
                            <Col xs={24} md={8}>
                                <Form.Item
                                    label="Xã, phường"
                                    name="wards_code"
                                    rules={[{ required: false, message: "Bắt buộc chọn" }]}
                                >
                                    <BaseSelect
                                        options={wards || []}
                                        optionValue="code"
                                        optionLabel="name"
                                        showSearch
                                        placeholder="Chọn một bản ghi"
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item
                                    label="Địa chỉ"
                                    name="address"
                                    rules={[{ required: false, message: "Bắt buộc nhập" }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16} className='mb-5'>
                            <Col xs={24} md={24}>
                                <FamilyRelationships required={false} listName="family_relationships" groupName="additional_info" form={form} />
                            </Col>
                        </Row>
                    </Card>
                </Form>
            )}
        </Drawer>
    )
}

export default CreateProfileForm;